import { onMounted, toRaw } from 'vue';
import { useAppStore } from '@/store/appStore';
import { LoginSessionKey } from '@/enum/app.ts';
import { resolveNexusUnionId } from '@/utils/nexus.ts';

function parseJson(text: string): any {
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
}

/**
 * nexus 展示环境跳板：v1 收到宿主 setEnv=nexus 后，把演示身份写入 sessionStorage
 * 后跳转 web-v2（nexus 实际驻留页面）。v2 守卫按 source='nexus' 免扫码登录
 * （后端 NEXUS_DEMO_UNION_IDS 白名单放行），演示数据/权限与真人一致，
 * v1 侧无需建会话。
 *
 * 演示身份取 ?nexus_union_id= / VITE_NEXUS_UNION_ID；两者都缺省时无法自动建立
 * 会话，web-v2 将落到登录页（可扫码登录）。
 */
export function useNexusEnv() {
  const appStore = useAppStore();

  onMounted(() => {
    window.addEventListener('message', (msg) => onMessage(msg.data));
    document.addEventListener('message', (msg) =>
      onMessage((msg as MessageEvent).data),
    );
  });

  async function onMessage(msg: unknown) {
    if (msg) {
      try {
        const data = typeof msg === 'string' ? parseJson(msg) : msg;
        if (data?.type === 'setEnv' && data.env === 'nexus') {
          const isNexus = toRaw(appStore.isNexus);
          appStore.toggleNexus(true);
          if (!isNexus) {
            const unionId = resolveNexusUnionId();
            if (unionId) {
              sessionStorage.setItem(
                LoginSessionKey.NEXUS_BRIDGE,
                JSON.stringify({ dd_union_id: unionId, source: 'nexus' }),
              );
            } else {
              console.warn(
                '[nexus] 演示身份未配置（?nexus_union_id= / VITE_NEXUS_UNION_ID），无法自动建立会话',
              );
            }
            window.location.href = '/web-v2/';
          }
        }
      } catch (e) {
        console.error('[nexus] 跳板登录失败：', e);
      }
    }
  }
}
